import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import TextImageSection from "../Home/component/TextImageSection";
import support from "../../assets/Images/Home/support.jpg";
import supportChat from "../../assets/Images/Home/support-chat.jpg";
import supportLoan from "../../assets/Images/Home/supportLoan.jpg";
// import FormComponent from "../Contact/FormComponent";
import { Blog } from "../Blogs/BlogComponent";
import DropDown from "../../components/Dropdown";
import { useState } from "react";
import { DeskotopIcon, genaral_support } from "../LandingPage/components/SvgIcon";

export const SupportPage = () => {
  const blogs = [
    {
      placeholderImage: supportChat,
      description:
        "At FastFin, we recognize the challenges of unexpected expenses and aim to break through traditional banking barriers to provide timely.",
      time: "5",
      readMoreLink: "#",
    },
    {
      placeholderImage: supportLoan,
      description:
        "At FastFin, we recognize the challenges of unexpected expenses and aim to break through traditional banking barriers to provide timely.",
      time: "5",
      readMoreLink: "#",
    },
  ];
  const [category, setCategory] = useState("");
  const options = ["Loan Support", "General Support"];
  const [formData, setFormData] = useState({
    category: "",
    email: "",
    mobileNumber: "",
    title: "",
    query: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };

  return (
    <>
      <Navbar />
      <div className="home-section flex items-center">
        <TextImageSection
          view={"heading-then-image"}
          image={support}
          heading={"Need Assistance? We’re Here to Help!"}
          custumeClass="center-section leading-partner image-hr-text insta-loan credit-tool-instaloan loan-product-page blogs-page"
        ></TextImageSection>
        <div className="blogs-section-container">
          <Blog blogs={blogs} />
        </div>
      </div>

      <form className="support-page-form" onSubmit={handleSubmit}>
        <p>We’re here to help.</p> <p>Please share your concerns</p>
        <div className="contact-us support-page">
          <div className="heading-contact">
            <div className="form-group">
              <h3 className="form_heading">
                {DeskotopIcon} Help me with
              </h3>
              <DropDown
                options={options}
                title="Select Category"
                name="category"
                value={category}
                onSelect={(data) => {
                  setFormData({ ...formData, category: data });
                  setCategory(data);
                }}
              />
            </div>
          </div>
          <div className="support-form">
            <h3 className="form_heading">{genaral_support} General Support</h3>
            {/* <FormComponent /> */}
            <div className="form-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="tel"
                id="mobileNumber"
                name="mobileNumber"
                placeholder="Number *"
                value={formData.mobileNumber}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                id="title"
                name="title"
                placeholder="Title *"
                value={formData.loanType}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <textarea
                id="Query"
                name="query"
                placeholder="Query *"
                value={formData.description}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-button-form">
              Submit
            </button>
          </div>
        </div>
      </form>

      <Footer custumeClass="landing-page-footer !bg-inherit !border-0" />
    </>
  );
};
